"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var mobileStylesHelper_1 = require("../assets/mobileStylesHelper");

var mobile = {};
exports.styles = __assign({
  '@font-face': {
    fontFamily: '\'mrg-rouble\'',
    // tslint:disable-next-line
    src: 'url("data:application/font-woff;base64,d09GRgABAAAAAAXAAAwAAAAABXAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAABHU1VCAAABHAAAAGAAAABg2UvcPk9TLzIAAAF8AAAAYAAAAGAREyzoY21hcAAAAdwAAABkAAAAZOf1PjdnYXNwAAACQAAAAAgAAAAIAAAAEGdseWYAAAJIAAABLAAAASwkv1HKaGVhZAAAA3QAAAA2AAAANhBRE19oaGVhAAADrAAAACQAAAAkB0IDyWhtdHgAAAPQAAAAIAAAACAKAACAbG9jYQAAA/AAAAASAAAAEgDwAMhtYXhwAAAEBAAAACAAAAAgAAsAR25hbWUAAAQkAAABegAAAXqoBB5fcG9zdAAABaAAAAAgAAAAIAADAAAAAQAAAAoAHgAsAAFsYXRuAAgABAAAAAAAAAABAAAAAWxpZ2EACAAAAAEAAAABAAQABAAAAAEACgAAAAEACgACABIAHAABAAIABQAHAAEABAAGAAIABAABAAQABgACAAcAAwMAAZAABQAAApkCzAAAAI8CmQLMAAAB6wAzAQkAAAAAAAAAAAAAAAAAAAIBAAAAAgAAAAAAAAAAAAAAAABAAAAgvgPA/8AAQAPAAEAAAAABAAAAAAAAAAAAAAAgAAAAAAADAAAAAwAAABwAAQADAAAAHAADAAEAAAAcAAQASAAAAA4ACAACAAYAAQAgAC4EQCC+//3//wAAAAAAIAAuBEAgvf/9//8AAf/j/9b7xd9JAAMAAQAAAAAAAAAAAAAAAAAAAAEAAf//AA8AAQAAAAAAAAAAAAIAADc5AQAAAAABAAAAAAAAAAAAAgAANzkBAAAAAAEAAAAAAAAAAAACAAA3OQEAAAAAAQAAAAAAAAAAAAIAADc5AQAAAAABAAAAAAAAAAAAAgAANzkBAAAAAAIAgAAAA4ADgAA6AEQAAAEyFx4BFxYVFAcOAQcGKwEVITIWFRQGIzEhFRQGIyImNTE1IyImNTQ2MzEzNSMiJjU0NjMxMxE0NjMxBSMRMzI2NTQmIwJgPDQ1ThYXFxZONTQ84AEDGyUlG/79JRsbJUAbJSUbQEAbJSUbQCUbASDg4EJeXkIDgBcWTjU0PDw0NU4WF0AlGxslQBslJRtAJRsbJUAlGxslAYAbJYD+wF5CQl4AAAEAAAAAAAAAAAACAAA3OQEAAAAAAQAAAAEAAHOQHT1fDzz1AAsEAAAAAADW2WdxAAAAANbZZ3EAAAAAA4ADgAAAAAgAAgAAAAAAAAABAAADwP/AAAAEAAAAAAADgAABAAAAAAAAAAAAAAAAAAAACAQAAAAAAAAAAAAAAAIAAAAAAAAAAAAAAAQAAIAAAAAAAAAAAAAKABQAHgAoADIAjACWAAAAAQAAAAgARQACAAAAAAACAAAAAAAAAAAAAAAAAAAAAAAAAA4ArgABAAAAAAABAAYAAAABAAAAAAACAAcAVwABAAAAAAADAAYAMwABAAAAAAAEAAYAbAABAAAAAAAFAAsAEgABAAAAAAAGAAYARQABAAAAAAAKABoAfgADAAEECQABAAwABgADAAEECQACAA4AXgADAAEECQADAAwAOQADAAEECQAEAAwAcgADAAEECQAFABYAHQADAAEECQAGAAwASwADAAEECQAKADQAmHJvdWJsZQByAG8AdQBiAGwAZVZlcnNpb24gMS4wAFYAZQByAHMAaQBvAG4AIAAxAC4AMHJvdWJsZQByAG8AdQBiAGwAZXJvdWJsZQByAG8AdQBiAGwAZVJlZ3VsYXIAUgBlAGcAdQBsAGEAcnJvdWJsZQByAG8AdQBiAGwAZUZvbnQgZ2VuZXJhdGVkIGJ5IEljb01vb24uAEYAbwBuAHQAIABnAGUAbgBlAHIAYQB0AGUAZAAgAGIAeQAgAEkAYwBvAE0AbwBvAG4ALgAAAAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA=") format("woff")',
    fontWeight: 'normal',
    fontStyle: 'normal'
  },
  rouble: {
    fontFamily: '\'mrg-rouble\'',
    fontSize: '0.8em'
  }
}, mobileStylesHelper_1.default(mobile));